export default {
	"59f427f8a784f5dfd334c24fcba8d0ea": "Temporarily unavailable for purchase",
	"d7d69f044ea5e5933ca6abc5feeb136e": "Please purchase it on the Jiaojiao APP",
	"03add21c28182a5ede3db8319261dec3": "Cancel",
	"064de6394cb32ac98107b8d4bbb0124b": "Head to the Jiaojiao APP"
}
